import React, { useState, useMemo } from 'react';
import './styles.css';
import LinkBuilder from '../../../../helpers/link-builder';
import {Role, Option} from '../../../../helpers/user';
import UxHelpers from '../../../../helpers/ux-helpers';
import ChatDropdown from './components/ChatDropdown';
import InboxDropdown from './components/InboxDropdown';
import ProfileDropdown from './components/ProfileDropdown';

const UserMenu = props => {
  const { user, counters, actions } = props;
  const { name, avatar } = user;
  const { toggleMobileMenuHandler } = actions;

  const [dropDownState, setDropDownState] = useState({
    inbox: false,
    profile: false,
    chat: false,
  });

  const [showInbox] = useMemo(
    () => [
      Role.isCandidate(user) || Role.isRecruiter(user),
      Option.isGmailInviteAvailable(user.options),
    ],
    [user]
  );

  const toggleDropdown = dropdown => {
    // toggle the right one
    switch (dropdown) {
      case 'chat':
        setDropDownState({
          inbox: false,
          profile: false,
          chat: !dropDownState.chat,
        });
        dropDownState.chat
          ? UxHelpers.scrollLock('unlock')
          : UxHelpers.scrollLock('lock');
        toggleMobileMenuHandler(false);
        break;
      case 'inbox':
        setDropDownState({
          inbox: !dropDownState.inbox,
          profile: false,
          chat: false,
        });
        dropDownState.inbox
          ? UxHelpers.scrollLock('unlock')
          : UxHelpers.scrollLock('lock');
        toggleMobileMenuHandler(false);
        break;
      case 'profile':
        setDropDownState({
          inbox: false,
          profile: !dropDownState.profile,
          chat: false,
        });
        dropDownState.profile
          ? UxHelpers.scrollLock('unlock')
          : UxHelpers.scrollLock('lock');
        toggleMobileMenuHandler(false);
        break;
      case 'outsideProf':
        setDropDownState({
          ...dropDownState,
          profile: false,
        });
        UxHelpers.scrollLock('unlock');
        toggleMobileMenuHandler(false);
        break;
      case 'outsideChat':
        setDropDownState({
          ...dropDownState,
          chat: false,
        });
        UxHelpers.scrollLock('unlock');
        toggleMobileMenuHandler(false);
        break;
      case 'outsideInbox':
        setDropDownState({
          ...dropDownState,
          inbox: false,
        });
        UxHelpers.scrollLock('unlock');
        toggleMobileMenuHandler(false);
        break;
      default:
        toggleMobileMenuHandler(false);
        break;
    }
  };

  const showUpgradeAccountLink = useMemo(
    () =>
      (Role.isCandidate(user) || Role.isRecruiterDefault(user)) &&
      !!user.accountUpgradeType,
    [user]
  );

  return (
    <nav
      className={
        window.gbsChat ? 'user-menu user-menu--with-chat' : 'user-menu'
      }
    >
      {window.gbsChat && (
        <div className="user-menu-item">
          <ChatDropdown
            disableOnClickOutside={dropDownState.chat === true}
            toggled={dropDownState.chat}
            toggleFunc={toggleDropdown}
            outsideClickIgnoreClass="ignore-react-onclickoutside"
            stopPropagation={true}
          />
        </div>
      )}
      {showInbox && (
        <div className="user-menu-item">
          <InboxDropdown
            disableOnClickOutside={dropDownState.inbox === true}
            messageCounter={counters.inbox}
            toggled={dropDownState.inbox}
            toggleFunc={toggleDropdown}
            outsideClickIgnoreClass="ignore-react-onclickoutside"
            stopPropagation={true}
          />
        </div>
      )}
      <div className="user-menu-item">
        <ProfileDropdown
          accountType={user.accountType}
          disableOnClickOutside={dropDownState.profile === true}
          name={name}
          upgradeLink={showUpgradeAccountLink}
          upgradeType={user.accountUpgradeType}
          avatar={LinkBuilder.getCandidatePictureSizeLink(avatar, '45x45')}
          toggled={dropDownState.profile}
          toggleFunc={toggleDropdown}
        />
      </div>
    </nav>
  );
};

export default UserMenu;
